<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M12.4925 15.9827C12.2204 16.2722 11.7792 16.2722 11.5071 15.9827L5.00389 9.06507C4.73178 8.77562 4.73178 8.30634 5.00389 8.01689C5.27599 7.72744 5.71717 7.72744 5.98927 8.01689L11.9998 14.4104L18.0103 8.01689C18.2824 7.72744 18.7236 7.72744 18.9957 8.01689C19.2678 8.30634 19.2678 8.77563 18.9957 9.06507L12.4925 15.9827Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronDown',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
